document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'ventureCompareBikes';

  const container = document.querySelector('[data-venture-compare-page]');

  if (!container) {
    return;
  }

  let desktopOffset = 0;
  let sliderBusy = false;

  let stickyScrollHandler = null;
  let stickyResizeHandler = null;

  function getSelectedBikes() {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      return [];
    }
  }

  function saveSelectedBikes(bikes) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(bikes));
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function displayValue(value) {
    return value && String(value).trim() !== ''
      ? escapeHtml(value)
      : '—';
  }

  function getRows() {
    return [
      { label: 'Price', key: 'price' },
      { label: 'Max Range', key: 'range' },
      { label: 'Max Speed', key: 'speed' },
      { label: 'Peak Power', key: 'power' },
      { label: 'Motor', key: 'motor' },
      { label: 'Battery', key: 'battery' },
      { label: 'Sensor Type', key: 'sensor' },
      { label: 'Weight', key: 'weight' },
      { label: 'Total Weight Limit', key: 'weightLimit' },
      { label: 'Throttle', key: 'throttle' }
    ];
  }

  function renderEmptyState() {
    cleanupStickyHeaderListeners();

    container.innerHTML = `
      <div class="venture-compare-empty">
        <h2>No eBikes selected yet</h2>
        <p>Select eBikes from the eBike collection to compare them here.</p>

        <a
          class="venture-compare-empty__button"
          href="/collections/ebikes"
        >
          Shop eBikes
        </a>
      </div>
    `;
  }

  function renderBikeHeader(bike, isReference) {
    return `
      <div class="venture-slider-bike-header ${isReference ? 'is-reference' : ''}">

        ${
          isReference
            ? '<div class="venture-compare-primary-badge">Reference</div>'
            : ''
        }

        ${
          bike.image
            ? `
              <a href="${escapeHtml(bike.url)}">
                <img
                  class="venture-slider-bike-header__image"
                  src="${escapeHtml(bike.image)}"
                  alt="${escapeHtml(bike.title)}"
                  draggable="false"
                >
              </a>
            `
            : ''
        }

        <a
          class="venture-slider-bike-header__title"
          href="${escapeHtml(bike.url)}"
        >
          ${escapeHtml(bike.title)}
        </a>

        <div class="venture-slider-bike-header__price">
          ${displayValue(bike.price)}
        </div>

        <div class="venture-slider-bike-header__actions">

          ${
            !isReference
              ? `
                <button
                  type="button"
                  data-venture-make-reference="${escapeHtml(bike.id)}"
                >
                  Make Reference
                </button>
              `
              : ''
          }

          <button
            type="button"
            data-venture-remove-bike="${escapeHtml(bike.id)}"
          >
            Remove
          </button>

        </div>

      </div>
    `;
  }

  function renderSpecColumn(rows) {
    let html = `
      <div class="venture-slider-spec-column">

        <div class="venture-slider-spec-column__header">
          Specifications
        </div>
    `;

    rows.forEach(function (row) {
      html += `
        <div class="venture-slider-spec-column__row">
          ${escapeHtml(row.label)}
        </div>
      `;
    });

    html += `</div>`;

    return html;
  }

  function renderBikeColumn(bike, isReference) {
    const rows = getRows();

    let html = `
      <div
        class="venture-slider-bike-column ${isReference ? 'is-reference' : ''}"
        data-slider-bike-id="${escapeHtml(bike.id)}"
      >

        <div class="venture-slider-bike-column__header">
          ${renderBikeHeader(bike, isReference)}
        </div>
    `;

    rows.forEach(function (row) {
      html += `
        <div class="venture-slider-bike-column__value">
          ${displayValue(bike[row.key])}
        </div>
      `;
    });

    html += `</div>`;

    return html;
  }

  function renderStickyBike(bike, isReference) {
    return `
      <div
        class="
          venture-sticky-compare__bike
          ${isReference ? 'is-reference' : ''}
        "
      >

        ${
          bike.image
            ? `
              <img
                class="venture-sticky-compare__image"
                src="${escapeHtml(bike.image)}"
                alt=""
                draggable="false"
              >
            `
            : ''
        }

        <div class="venture-sticky-compare__bike-info">

          ${
            isReference
              ? `
                <span class="venture-sticky-compare__badge">
                  Reference
                </span>
              `
              : ''
          }

          <span class="venture-sticky-compare__title">
            ${escapeHtml(bike.title)}
          </span>

        </div>

      </div>
    `;
  }

  function renderStickyHeader(referenceBike, orderedBikes) {
    let movableHtml = '';

    orderedBikes.forEach(function (bike) {
      movableHtml += renderStickyBike(bike, false);
    });

    return `
      <div
        class="venture-sticky-compare"
        data-venture-sticky-compare
        aria-hidden="true"
      >
        <div
          class="venture-sticky-compare__inner"
          style="--venture-sticky-bike-count: ${orderedBikes.length};"
        >

          <div class="venture-sticky-compare__specs">
            Specs
          </div>

          ${renderStickyBike(referenceBike, true)}

          <div class="venture-sticky-compare__movables">
            ${movableHtml}
          </div>

        </div>
      </div>
    `;
  }

  function rotateArray(items, offset) {
    if (!items.length) {
      return [];
    }

    const normalized =
      ((offset % items.length) + items.length) % items.length;

    return items
      .slice(normalized)
      .concat(items.slice(0, normalized));
  }

  function renderDesktop(bikes) {
    const referenceBike = bikes[0];
    const otherBikes = bikes.slice(1);
    const rows = getRows();

    if (!otherBikes.length) {
      return `
        <div class="venture-compare-desktop">

          <div class="venture-slider-table">

            ${renderSpecColumn(rows)}

            ${renderBikeColumn(referenceBike, true)}

          </div>

          <div class="venture-slider-single-message">
            Select at least one more eBike to compare.
          </div>

        </div>
      `;
    }

    const orderedBikes = rotateArray(otherBikes, desktopOffset);

    const firstBike = orderedBikes[0];
    const lastBike = orderedBikes[orderedBikes.length - 1];

    let trackHtml = '';

    if (orderedBikes.length > 1) {
      trackHtml += renderBikeColumn(lastBike, false);
    }

    orderedBikes.forEach(function (bike) {
      trackHtml += renderBikeColumn(bike, false);
    });

    if (orderedBikes.length > 1) {
      trackHtml += renderBikeColumn(firstBike, false);
    }

    return `
      <div class="venture-compare-desktop">

        ${renderStickyHeader(referenceBike, orderedBikes)}

        <div class="venture-slider-controls">

          <button
            type="button"
            class="venture-slider-arrow venture-slider-arrow--left"
            data-venture-slider-left
            aria-label="Previous comparison bike"
            ${orderedBikes.length <= 1 ? 'disabled' : ''}
          >
            ‹
          </button>

          <div class="venture-slider-controls__text">

            <strong>
              Slide through your selected bikes
            </strong>

            <span>
              Use the arrows or drag to move another bike next to your Reference
            </span>

          </div>

          <button
            type="button"
            class="venture-slider-arrow venture-slider-arrow--right"
            data-venture-slider-right
            aria-label="Next comparison bike"
            ${orderedBikes.length <= 1 ? 'disabled' : ''}
          >
            ›
          </button>

        </div>

        <div
          class="venture-slider-table"
          data-venture-slider-table
          style="--venture-movable-count: ${orderedBikes.length};"
        >

          ${renderSpecColumn(rows)}

          ${renderBikeColumn(referenceBike, true)}

          <div
            class="venture-slider-viewport"
            data-venture-slider-viewport
          >

            <div
              class="venture-slider-track"
              data-venture-slider-track
              data-slider-count="${orderedBikes.length}"
            >
              ${trackHtml}
            </div>

          </div>

        </div>

      </div>
    `;
  }

  function renderMobileComparison(referenceBike, bike) {
    const rows = getRows();

    let html = `
      <article class="venture-mobile-compare-card">

        <div class="venture-mobile-compare-card__top">

          <div>

            <span class="venture-compare-primary-badge">
              Reference
            </span>

            ${
              referenceBike.image
                ? `
                  <img
                    src="${escapeHtml(referenceBike.image)}"
                    alt="${escapeHtml(referenceBike.title)}"
                  >
                `
                : ''
            }

            <strong>
              ${escapeHtml(referenceBike.title)}
            </strong>

          </div>

          <div>

            ${
              bike.image
                ? `
                  <img
                    src="${escapeHtml(bike.image)}"
                    alt="${escapeHtml(bike.title)}"
                  >
                `
                : ''
            }

            <strong>
              ${escapeHtml(bike.title)}
            </strong>

          </div>

        </div>

        <div class="venture-mobile-compare-card__specs">
    `;

    rows.forEach(function (row) {
      html += `
        <div class="venture-mobile-compare-row">

          <div class="venture-mobile-compare-row__label">
            ${escapeHtml(row.label)}
          </div>

          <div>
            ${displayValue(referenceBike[row.key])}
          </div>

          <div>
            ${displayValue(bike[row.key])}
          </div>

        </div>
      `;
    });

    html += `
        </div>

        <div class="venture-mobile-compare-card__actions">

          <button
            type="button"
            data-venture-make-reference="${escapeHtml(bike.id)}"
          >
            Make Reference
          </button>

          <button
            type="button"
            data-venture-remove-bike="${escapeHtml(bike.id)}"
          >
            Remove
          </button>

        </div>

      </article>
    `;

    return html;
  }

  function renderMobile(bikes) {
    const referenceBike = bikes[0];

    if (bikes.length === 1) {
      return `
        <div class="venture-compare-mobile">

          <div class="venture-mobile-single-bike">

            ${renderBikeHeader(referenceBike, true)}

            <p>
              Select at least one more eBike to compare against your Reference bike.
            </p>

          </div>

        </div>
      `;
    }

    let html = `
      <div class="venture-compare-mobile">

        <div class="venture-compare-mobile__summary">

          <strong>
            Comparing ${bikes.length} eBikes
          </strong>

          <span>
            Reference: ${escapeHtml(referenceBike.title)}
          </span>

        </div>
    `;

    bikes.slice(1).forEach(function (bike) {
      html += renderMobileComparison(referenceBike, bike);
    });

    html += `</div>`;

    return html;
  }

  function cleanupStickyHeaderListeners() {
    if (stickyScrollHandler) {
      window.removeEventListener(
        'scroll',
        stickyScrollHandler
      );

      stickyScrollHandler = null;
    }

    if (stickyResizeHandler) {
      window.removeEventListener(
        'resize',
        stickyResizeHandler
      );

      stickyResizeHandler = null;
    }
  }

  function renderPage() {
    const bikes = getSelectedBikes();

    cleanupStickyHeaderListeners();

    if (!bikes.length) {
      renderEmptyState();
      return;
    }

    const otherBikeCount = Math.max(0, bikes.length - 1);

    if (otherBikeCount > 0) {
      desktopOffset =
        ((desktopOffset % otherBikeCount) + otherBikeCount) %
        otherBikeCount;
    } else {
      desktopOffset = 0;
    }

    container.innerHTML = `
      <div class="venture-compare-page__selected-count">
        ${bikes.length} of 4 eBikes selected
      </div>

      ${renderDesktop(bikes)}

      ${renderMobile(bikes)}
    `;

    initializeDesktopSlider();
  }

  function makeReference(productId) {
    const bikes = getSelectedBikes();

    const index = bikes.findIndex(function (bike) {
      return bike.id === productId;
    });

    if (index <= 0) {
      return;
    }

    const selectedBike = bikes.splice(index, 1)[0];

    bikes.unshift(selectedBike);

    saveSelectedBikes(bikes);

    desktopOffset = 0;

    renderPage();
  }

  function removeBike(productId) {
    const bikes = getSelectedBikes().filter(function (bike) {
      return bike.id !== productId;
    });

    saveSelectedBikes(bikes);

    desktopOffset = 0;

    renderPage();
  }

  function getColumnWidth(track) {
    const column = track.querySelector(
      '.venture-slider-bike-column'
    );

    if (!column) {
      return 0;
    }

    return column.getBoundingClientRect().width;
  }

  function setTrackPosition(track, x, animate) {
    track.style.transition =
      animate ? 'transform 260ms ease' : 'none';

    track.style.transform =
      `translate3d(${x}px, 0, 0)`;
  }

  function initializeDesktopSlider() {
    const viewport = container.querySelector(
      '[data-venture-slider-viewport]'
    );

    const track = container.querySelector(
      '[data-venture-slider-track]'
    );

    if (!viewport || !track) {
      initializeStickyHeader();
      return;
    }

    const count = parseInt(
      track.dataset.sliderCount || '0',
      10
    );

    if (count <= 1) {
      setTrackPosition(track, 0, false);

      initializeStickyHeader();

      return;
    }

    requestAnimationFrame(function () {
      const width = getColumnWidth(track);

      setTrackPosition(track, -width, false);
    });

    initializeDrag(viewport, track);

    initializeStickyHeader();
  }

  function moveSlider(direction) {
    if (sliderBusy) {
      return;
    }

    const track = container.querySelector(
      '[data-venture-slider-track]'
    );

    if (!track) {
      return;
    }

    const count = parseInt(
      track.dataset.sliderCount || '0',
      10
    );

    if (count <= 1) {
      return;
    }

    const width = getColumnWidth(track);

    if (!width) {
      return;
    }

    sliderBusy = true;

    const target =
      direction === 1
        ? -2 * width
        : 0;

    setTrackPosition(track, target, true);

    window.setTimeout(function () {
      desktopOffset += direction;

      sliderBusy = false;

      renderPage();
    }, 270);
  }

  function initializeDrag(viewport, track) {
    let dragging = false;
    let startX = 0;
    let currentX = 0;
    let pointerId = null;
    let startLink = null;
    let actuallyDragged = false;
    let suppressClickUntil = 0;

    const count = parseInt(
      track.dataset.sliderCount || '0',
      10
    );

    if (count <= 1) {
      return;
    }

    function pointerDown(event) {
      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      if (event.target.closest('button')) {
        return;
      }

      if (sliderBusy) {
        return;
      }

      const width = getColumnWidth(track);

      if (!width) {
        return;
      }

      dragging = true;
      actuallyDragged = false;

      pointerId = event.pointerId;
      startX = event.clientX;
      currentX = startX;

      startLink = event.target.closest('a');

      viewport.classList.add('is-dragging');

      viewport.setPointerCapture(pointerId);

      setTrackPosition(track, -width, false);

      event.preventDefault();
    }

    function pointerMove(event) {
      if (!dragging) {
        return;
      }

      currentX = event.clientX;

      const width = getColumnWidth(track);
      const delta = currentX - startX;

      if (Math.abs(delta) > 6) {
        actuallyDragged = true;
      }

      setTrackPosition(
        track,
        -width + delta,
        false
      );

      event.preventDefault();
    }

    function finishDrag() {
      if (!dragging) {
        return;
      }

      dragging = false;

      viewport.classList.remove('is-dragging');

      if (
        pointerId !== null &&
        viewport.hasPointerCapture(pointerId)
      ) {
        viewport.releasePointerCapture(pointerId);
      }

      const width = getColumnWidth(track);
      const delta = currentX - startX;

      if (!actuallyDragged) {
        setTrackPosition(track, -width, true);

        if (startLink && startLink.href) {
          window.location.href = startLink.href;
        }

        startLink = null;

        return;
      }

      suppressClickUntil = Date.now() + 400;

      startLink = null;

      const threshold = width * 0.25;

      if (delta <= -threshold) {
        moveSlider(1);
        return;
      }

      if (delta >= threshold) {
        moveSlider(-1);
        return;
      }

      setTrackPosition(track, -width, true);
    }

    viewport.addEventListener(
      'pointerdown',
      pointerDown
    );

    viewport.addEventListener(
      'pointermove',
      pointerMove
    );

    viewport.addEventListener(
      'pointerup',
      finishDrag
    );

    viewport.addEventListener(
      'pointercancel',
      finishDrag
    );

    viewport.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      }
    );

    viewport.addEventListener(
      'click',
      function (event) {
        if (Date.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  }

  function getVisibleSiteHeaderBottom() {
    const selectors = [
      '.site-header',
      '.site-header-main',
      '.site-header-sticky'
    ];

    let bottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        const rect = element.getBoundingClientRect();
        const styles = window.getComputedStyle(element);

        const isStickyOrFixed =
          styles.position === 'sticky' ||
          styles.position === 'fixed';

        if (
          isStickyOrFixed &&
          rect.bottom > 0 &&
          rect.top <= 5
        ) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });
    });

    return Math.max(0, Math.round(bottom));
  }

  function updateStickyHeader() {
    const sticky = container.querySelector(
      '[data-venture-sticky-compare]'
    );

    const table = container.querySelector(
      '[data-venture-slider-table]'
    );

    if (!sticky || !table) {
      return;
    }

    if (window.innerWidth < 1024) {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
      return;
    }

    const siteHeaderBottom = getVisibleSiteHeaderBottom();

    sticky.style.setProperty(
      '--venture-sticky-top',
      siteHeaderBottom + 'px'
    );

    const tableRect = table.getBoundingClientRect();

    /*
     * The normal large bike header is 280px tall.
     * Show the compact header only after that header
     * has scrolled away.
     */
    const normalBikeHeaderBottom =
      tableRect.top + 280;

    const stickyHeight =
      sticky.getBoundingClientRect().height || 72;

    const passedBikeHeaders =
      normalBikeHeaderBottom <= siteHeaderBottom;

    const stillInsideTable =
      tableRect.bottom >
      siteHeaderBottom + stickyHeight + 8;

    if (passedBikeHeaders && stillInsideTable) {
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function initializeStickyHeader() {
    const sticky = container.querySelector(
      '[data-venture-sticky-compare]'
    );

    const table = container.querySelector(
      '[data-venture-slider-table]'
    );

    if (!sticky || !table) {
      return;
    }

    cleanupStickyHeaderListeners();

    let scrollTicking = false;

    stickyScrollHandler = function () {
      if (scrollTicking) {
        return;
      }

      scrollTicking = true;

      window.requestAnimationFrame(function () {
        updateStickyHeader();
        scrollTicking = false;
      });
    };

    stickyResizeHandler = function () {
      updateStickyHeader();
    };

    window.addEventListener(
      'scroll',
      stickyScrollHandler,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      stickyResizeHandler
    );

    updateStickyHeader();
  }

  container.addEventListener('click', function (event) {
    const makeReferenceButton = event.target.closest(
      '[data-venture-make-reference]'
    );

    if (makeReferenceButton) {
      makeReference(
        makeReferenceButton.dataset.ventureMakeReference
      );

      return;
    }

    const removeButton = event.target.closest(
      '[data-venture-remove-bike]'
    );

    if (removeButton) {
      removeBike(
        removeButton.dataset.ventureRemoveBike
      );

      return;
    }

    const leftArrow = event.target.closest(
      '[data-venture-slider-left]'
    );

    if (leftArrow) {
      moveSlider(-1);

      return;
    }

    const rightArrow = event.target.closest(
      '[data-venture-slider-right]'
    );

    if (rightArrow) {
      moveSlider(1);
    }
  });

  renderPage();
});